export const fmtGBP = (n) =>
  n == null ? "—" : "£" + Number(n).toLocaleString("en-GB", { maximumFractionDigits: 0 });

export const fmtMoney = (n, c) =>
  n == null ? "—" : `${c ? c + " " : ""}${Number(n).toLocaleString("en-GB", { maximumFractionDigits: 0 })}`;

export const fmtDate = (d) =>
  d ? new Date(d).toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" }) : "—";

export const statusTone = {
  Sold: "bg-emerald-500/15 text-emerald-400 border border-emerald-500/30",
  Unsold: "bg-red-500/15 text-red-400 border border-red-500/30",
  Withdrawn: "bg-slate-500/15 text-slate-400 border border-slate-500/30",
};

export const HOUSES = ["Bonhams", "Christie's", "Sotheby's", "Phillips"];
export const CITIES = ["London", "New York"];
export const CATEGORIES = [
  "Paintings", "Drawings", "Prints", "Sculpture", "Works on Paper",
  "Old Masters", "Modern Art", "Contemporary Art",
];
